import { BikeState } from './bike';
import { BikeConfig } from './config';
import { Surface, Terrain, TerrainSample } from './terrain';

export interface Deformable extends Terrain { deform(x: number, z: number, depth: number, radius: number): void }

/** How easily each surface ruts, relative to sand-clay. */
export const RUT_SOFTNESS: Record<Surface, number> = { clay: 0.5, sandClay: 1, mud: 1.5, sand: 1.8, grass: 0.4, roots: 0.1, water: 0 };
export const RUT_RATE = 0.02;  // depth per metre rolled before falloff: ~8 mm per pass of both wheels on sand-clay
export const RUT_RADIUS = 0.3;
const PROBE: TerrainSample = { height: 0, normal: { x: 0, y: 1, z: 0 }, surface: 'clay' };

/** Presses both loaded wheels into the ground. Call once after each stepBike. */
export function applyRuts(bike: BikeState, terrain: Deformable, cfg: BikeConfig, dt: number): void {
  const vh = Math.hypot(bike.velocity.x, bike.velocity.z);
  if (vh < 0.2) return;
  for (let i = 0; i < 2; i++) {
    if (!bike.wheels[i]!.contact) continue;
    // Axle position: the bike's forward axis (from the quaternion, no allocation) times half the wheelbase.
    const q = bike.orientation, m = (i === 1 ? 0.5 : -0.5) * cfg.wheelbase;
    const x = bike.position.x + 2 * (q.x * q.z + q.y * q.w) * m, z = bike.position.z + (1 - 2 * (q.x * q.x + q.y * q.y)) * m;
    let surface: Surface;
    if (terrain.sampleInto) { terrain.sampleInto(x, z, PROBE); surface = PROBE.surface; } else surface = terrain.sample(x, z).surface;
    const soft = RUT_SOFTNESS[surface];
    if (soft > 0) terrain.deform(x, z, RUT_RATE * soft * vh * dt, RUT_RADIUS);
  }
}
